module.exports = __webpack_public_path__ + "static/media/sudoku-social.ac5fa44c.png";